import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './lib/auth-context.js';
import { HomePage } from './pages/Home.js';
import { CalendarPage } from './pages/Calendar.js';
import { TasksPage } from './pages/Tasks.js';
import { SwapsPage } from './pages/Swaps.js';
import { AdminPage } from './pages/Admin.js';
import { StaffPage } from './pages/Staff.js';
import { RosterEditor } from './pages/RosterEditor.js';
const qc = new QueryClient();
export function App() {
    return (_jsx(QueryClientProvider, { client: qc, children: _jsx(AuthProvider, { children: _jsx(BrowserRouter, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(HomePage, {}) }), _jsx(Route, { path: "/calendar", element: _jsx(CalendarPage, {}) }), _jsx(Route, { path: "/tasks", element: _jsx(TasksPage, {}) }), _jsx(Route, { path: "/swaps", element: _jsx(SwapsPage, {}) }), _jsx(Route, { path: "/admin", element: _jsx(AdminPage, {}) }), _jsx(Route, { path: "/admin/staff", element: _jsx(StaffPage, {}) }), _jsx(Route, { path: "/admin/roster", element: _jsx(RosterEditor, {}) })] }) }) }) }));
}
